<template>
    <div class="company-register-component">

		<form ref="form" v-on:submit.prevent="onSubmit" novalidate>
			<div class="row mb-4">
				<div class="col">
					<p class="h5 text-secondary font-weight-bold">{{ 'register.choose_industry' | translate }}</p>

					<div v-for="industry in industries" :key="industry.key" class="custom-control custom-radio custom-control-inline">
						<input type="radio" :id="'industry_' + industry.key" name="industry" :value="industry.key" v-model="form.industry" class="custom-control-input" :class="{'is-invalid': errors.industry}">
						<label class="custom-control-label" :for="'industry_' + industry.key">{{ industry.label }}</label>
					</div>
                    <div v-if="errors.industry" class="text-danger">
                        {{ errors.industry[0] }}
                    </div> 
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-sm-6">
					<p class="h5 text-secondary font-weight-bold">{{ 'register.company_data' | translate }}</p>

					<!-- name -->
					<div class="form-group row">
						<label for="name" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.name' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.name}" id="name" v-model="form.name" required>
							<div v-if="errors.name" class="invalid-feedback">
								{{ errors.name[0] }}
							</div> 
						</div>
					</div>
					
					<!-- address -->
					<div class="form-group row">
						<label for="address" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.address' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.address}" id="address" v-model="form.address" required>
							<div v-if="errors.address" class="invalid-feedback">
								{{ errors.address[0] }}
							</div> 
						</div>
					</div>
					
					<!-- zipcode -->
					<div class="form-group row">
						<label for="zipcode" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.zipcode' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.zipcode}" id="zipcode" v-model="form.zipcode" required>
							<div v-if="errors.zipcode" class="invalid-feedback">
								{{ errors.zipcode[0] }}
							</div> 
						</div>
					</div>
					
					<!-- city -->
					<div class="form-group row">
						<label for="city" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.city' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.city}" id="city" v-model="form.city" required>
							<div v-if="errors.city" class="invalid-feedback">
								{{ errors.city[0] }}
							</div> 
						</div>
					</div>
					
					<!-- country_id -->
					<div class="form-group row">
						<label for="country_id" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.country_id' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
                            <select class="form-control" :class="{'is-invalid': errors.country_id}" id="country_id" v-model="form.country_id" required>
                                <option value="">Geen</option>
                                <option v-for="country in countries" :key="country.id" :value="country.id">{{ country['name_' + language] }}</option>
                            </select>

							<div v-if="errors.country_id" class="invalid-feedback">
								{{ errors.country_id[0] }}
							</div> 
						</div>
					</div>
					
					<!-- coc -->
					<div class="form-group row">
						<label for="coc" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.coc' | translate }}</label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.coc}" id="coc" v-model="form.coc" required>
							<div v-if="errors.coc" class="invalid-feedback">
								{{ errors.coc[0] }}
							</div> 
						</div>
					</div>
					
					<!-- vat -->
					<div class="form-group row">
						<label for="vat" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.vat' | translate }}</label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.vat}" id="vat" v-model="form.vat" required>
							<div v-if="errors.vat" class="invalid-feedback">
								{{ errors.vat[0] }}
							</div> 
						</div>
					</div>
					
					<!-- website -->
					<div class="form-group row">
						<label for="website" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.website' | translate }}</label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.website}" id="website" v-model="form.website" required>
							<div v-if="errors.website" class="invalid-feedback">
								{{ errors.website[0] }}
							</div> 
						</div>
					</div>

				</div>
				<div class="col-sm-6">
					<p class="h5 text-secondary font-weight-bold">{{ 'register.contact_data' | translate }}</p>
					
					<!-- firstname -->
					<div class="form-group row">
						<label for="firstname" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.firstname' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.firstname}" id="firstname" v-model="form.firstname" required>
							<div v-if="errors.firstname" class="invalid-feedback">
								{{ errors.firstname[0] }}
							</div> 
						</div>
					</div>
					
					<!-- lastname -->
					<div class="form-group row">
						<label for="lastname" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.lastname' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="text" :class="{ 'form-control': true, 'is-invalid': errors.lastname}" id="lastname" v-model="form.lastname" required>
							<div v-if="errors.lastname" class="invalid-feedback">
								{{ errors.lastname[0] }}
							</div> 
						</div>
					</div>
					
					<!-- telephone -->
					<div class="form-group row">
						<label for="telephone" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.telephone' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="telephone" :class="{ 'form-control': true, 'is-invalid': errors.telephone}" id="telephone" v-model="form.telephone" required>
							<div v-if="errors.telephone" class="invalid-feedback">
								{{ errors.telephone[0] }}
							</div> 
						</div>
					</div>
					
					<!-- email -->
					<div class="form-group row">
						<label for="email" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.email' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="email" :class="{ 'form-control': true, 'is-invalid': errors.email}" id="email" v-model="form.email" required>
							<div v-if="errors.email" class="invalid-feedback">
								{{ errors.email[0] }}
							</div> 
						</div>
					</div>
					
					<!-- password -->
					<div class="form-group row">
						<label for="password" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.password' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="password" :class="{ 'form-control': true, 'is-invalid': errors.password}" id="password" v-model="form.password" required>
							<div v-if="errors.password" class="invalid-feedback">
								{{ errors.password[0] }}
							</div> 
						</div>
					</div>
					
					<!-- password_confirmation -->
					<div class="form-group row">
						<label for="password_confirmation" class="col-md-5 col-lg-4 col-xl-3 col-form-label">{{ 'register.password_confirmation' | translate }}<span class="required">*</span></label>
						<div class="col-md-7 col-lg-8 col-xl-9">
							<input type="password" :class="{ 'form-control': true, 'is-invalid': errors.password_confirmation}" id="password_confirmation" v-model="form.password_confirmation" required>
							<div v-if="errors.password_confirmation" class="invalid-feedback">
								{{ errors.password_confirmation[0] }}
							</div> 
						</div>
					</div>

				</div>
			</div>

			<div class="row">
				<div class="col">
					<p class="h5 text-secondary font-weight-bold">{{ 'register.timeslot_data' | translate }}</p>

                    <div class="timeslots border-left border-primary pl-2" style="border-width: 4px !important;" v-for="(timeslot, indexSlot) in form.timeslots" :key="indexSlot">

                        <div class="row mb-3">
                            <div class="col-md col-sm-6 col-6 mb-2" v-for="day in [1,2,3,4,5,6,7]" :key="day">
                                <!-- { 'btn-gray': !timeslot.days[day], 'btn-primary': timeslot.days[day] } -->
                                <div class="btn btn-sm btn-block" :class="[daySelected(timeslot.days, day) ? 'btn-primary' : 'btn-gray']" @click="toggleDay(timeslot.days, day)"> <!-- timeslot.days[day] = !timeslot.days[day] -->
                                    {{ 'days.day_' + day | translate }}
                                </div>
                            </div>
                            <div class="col-md col-sm-6 col-6" style="width: 60px; max-width: 60px;">
                                <div class="btn btn-sm btn-danger" v-if="indexSlot > 0" @click="removeTimeslot(indexSlot)">
                                    <i class="fas fa-trash"></i>
                                </div>
                            </div>
                            <div v-if="errors['timeslots.' + indexSlot + '.days']" class="col-md-12 text-danger">
								{{ errors['timeslots.' + indexSlot + '.days'][0] }}
							</div> 
                        </div>

                        <div class="timeslots-times my-3 my-md-5">
                            <div class="row" v-for="(time, index) in timeslot.times" :key="index">
                                <div class="col-sm mb-2 mb-md-0">
                                    <div class="form-inline">
                                        <label class="">{{ 'register.timeslot' | translate }} {{ index + 1 }}</label>
                                        <div class="w-100 d-block d-lg-none"></div>
                                        <label class="mr-2 ml-md-2 ml-lg-5 mr-lg-4">{{ 'register.time_from' | translate }}</label>
                                        
                                        <vue-timepicker format="HH:mm" v-model="time.from" hide-clear-button auto-scroll input-width="100px" :input-class="{'form-control': true, 'bg-white': true, 'is-invalid': !isValidTime(time.from)}"></vue-timepicker>

                                        <label class="mx-2 ml-lg-5 mr-lg-4">{{ 'register.time_to' | translate }}</label>

                                        <vue-timepicker format="HH:mm" v-model="time.to" hide-clear-button auto-scroll input-width="100px" :input-class="{'form-control': true, 'bg-white': true /*, 'is-invalid': !isValidTime(time.to)*/}"></vue-timepicker>

                                        <input type="text" class="form-control form-control-sm col-md-3 col-sm-10 mt-2 mt-md-0 ml-md-3" :placeholder="'register.time_description' | translate" v-model="time.description">
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-4">
                                    <div class="btn btn-danger" v-if="timeslot.times.length > 1" @click="removeTimeslotTime(timeslot.times, index)">
                                        <i class="fas fa-trash"></i>
                                    </div>
                                    <div class="btn btn-primary px-3" v-if="index == timeslot.times.length - 1" @click="addTimeslotTime(timeslot.times)">
                                        <i class="fas fa-plus pr-3"></i>{{ 'register.add_time' | translate }}
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="index != timeslot.times.length - 1">
                                    <hr>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="btn btn-primary" @click="addTimeslot">
                        {{ 'register.add_timeslot' | translate }}
                    </div>

                    <div v-if="!allTimesValid" class="text-danger mt-3">
                        {{ 'register.invalid_times_error' | translate }}
                    </div> 

				</div>
			</div>

            <div class="row mt-4">
                <div class="col">
                    
                    <div class="row">
                        <div class="col">

                            <!-- max_guests_inside -->
                            <div class="form-group row">
                                <label for="max_guests_inside" class="col-sm-8 col-form-label">{{ 'register.max_guests_inside' | translate }}<span class="required">*</span></label>
                                <div class="col-sm-4">
                                        <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.max_guests_inside}" id="max_guests_inside" v-model="form.max_guests_inside" required>
                                            <option value="">0</option>
                                            <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                                        </select>

                                    <div v-if="errors.max_guests_inside" class="invalid-feedback">
                                        {{ errors.max_guests_inside[0] }}
                                    </div> 
                                </div>
                            </div>

                        </div>
                        <div class="col">

                            <!-- max_guests_outside -->
                            <div class="form-group row">
                                <label for="max_guests_outside" class="col-sm-8 col-form-label">{{ 'register.max_guests_outside' | translate }}<span class="required">*</span></label>
                                <div class="col-sm-4">
                                        <select class="form-control" style="width: auto;" :class="{'is-invalid': errors.max_guests_outside}" id="max_guests_outside" v-model="form.max_guests_outside" required>
                                            <option value="">0</option>
                                            <option v-for="n in 100" :key="n" :value="n">{{ n }}</option>
                                        </select>

                                    <div v-if="errors.max_guests_outside" class="invalid-feedback">
                                        {{ errors.max_guests_outside[0] }}
                                    </div> 
                                </div>
                            </div>

                        </div>
                    </div>

					<!-- notify_guests -->
					<div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="notify_guests" :class="{'is-invalid': errors.notify_guests}" v-model="form.notify_guests">
                            <label class="custom-control-label" for="notify_guests">{{ 'register.notify_guests' | translate }}</label>
                        </div>

                        <div v-if="errors.notify_guests" class="invalid-feedback">
                            {{ errors.notify_guests[0] }}
                        </div>
					</div>

					<!-- reservation_description -->
					<div class="form-group row">
						<label for="reservation_description" class="col-sm-3 col-form-label">{{ 'register.reservation_description' | translate }}</label>
						<div class="col-sm-9">
							<textarea :class="{ 'form-control': true, 'is-invalid': errors.reservation_description}" id="reservation_description" v-model="form.reservation_description"></textarea>
							<div v-if="errors.reservation_description" class="invalid-feedback">
								{{ errors.reservation_description[0] }}
							</div> 
						</div>
					</div>

					<!-- install_service -->
					<div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="install_service" :class="{'is-invalid': errors.install_service}" @change="checkVouchercode()" v-model="form.install_service">
                            <label class="custom-control-label" for="install_service">{{ 'register.install_service' | translate }}</label>
                        </div>

                        <div v-if="errors.install_service" class="invalid-feedback">
                            {{ errors.install_service[0] }}
                        </div>
					</div>
					
					<!-- voucher_code -->
					<div class="form-group row">
						<label for="voucher_code" class="col-sm-3 col-form-label">{{ 'register.voucher_code' | translate }}</label>
						<div class="col-sm-9 col-md-3">
							<input type="text" :class="{ 'form-control': true, 'is-valid': price_info.voucher_discount > 0, 'is-invalid': errors.voucher_code}" id="voucher_code" v-model="form.voucher_code" @input="checkVouchercode()" required>
							<div v-if="errors.voucher_code" class="invalid-feedback">
								{{ errors.voucher_code[0] }}
							</div> 
						</div>
					</div>
                    
					<!-- accept_terms -->
					<div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="accept_terms" :class="{'is-invalid': errors.accept_terms}" v-model="form.accept_terms">
                            <label class="custom-control-label" for="accept_terms">{{ 'register.accept_terms' | translate }}</label>
                        </div>

                        <div v-if="errors.accept_terms" class="invalid-feedback">
                            {{ errors.accept_terms[0] }}
                        </div>
					</div>

                </div>
                <!-- <div class="col" style="flex: 0 0 260px; max-width: 260px;">
                    
					<! -- color_primary -- >
					<div class="form-group">
						<label for="color_primary" :class="{'text-danger': errors.color_primary}">{{ 'register.color_primary' | translate }}</label>

						<color-picker v-model="form.color_primary" />

						<div v-if="errors.color_primary" class="text-danger">
							{{ errors.color_primary[0] }}
						</div>
					</div>

                </div> -->
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="card">
                        <div class="card-body py-2 px-3">
                            <b>{{ 'register.totals.title' | translate }}</b>
                            
                            <table>
                                <tr>
                                    <td class="pr-4">{{ 'register.totals.base_price' | translate }}</td>
                                    <td>{{ price_info.base_price | currency }}</td>
                                </tr>
                                <tr v-if="form.install_service">
                                    <td class="pr-4">{{ 'register.totals.install_service' | translate }}</td>
                                    <td>{{ price_info.install_service | currency }}</td>
                                </tr>
                                <tr v-if="price_info.voucher_discount > 0">
                                    <td class="pr-4">{{ 'register.totals.voucher_discount' | translate }}</td>
                                    <td>{{ 0 - price_info.voucher_discount | currency }}</td>
                                </tr>
                                <tr>
                                    <td class="pr-4">{{ 'register.totals.total_excl' | translate }}</td>
                                    <td>{{ totalPrice | currency }}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <hr class="py-0 my-1 border-dark">
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pr-4">{{ 'register.totals.total_incl' | translate }}</td>
                                    <td class="text-primary font-weight-bold">{{ (totalPrice * price_info.tax) | currency }}</td>
                                </tr>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

			<button type="submit" class="btn btn-secondary mt-4" :disabled="!allTimesValid">{{ oprekening_betalen ? 'register.submit_oprekening' : 'register.submit' | translate }}</button>
		</form>

    </div>
</template>

<script>
    export default {
		name: 'company-register-component',
		props: [
			'industries',
			'countries',
			'registerUrl',
			'checkVouchercodeUrl',
		],
		data() {
			return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                price_info: {
                    tax: 1.21,
                    base_price: 1.95,
                    install_service: 35.00,
                    voucher_discount: 0,
                    total: 0,
                },
                oprekening_betalen: false,
				form: {
					industry: 'catering',
					name: '',
					address: '',
					zipcode: '',
					city: '',
					country_id: 'NL',
					coc: '',
					vat: '',
					website: '',
					firstname: '',
					lastname: '',
					telephone: '',
					email: '',
					password: '',
                    password_confirmation: '',
                    max_guests_inside: '',
                    max_guests_outside: '',
                    notify_guests: false,
                    color_primary: '#21ae5f',
                    install_service: false,
					timeslots: [
						{
                            days: [1],
							times: [
								{ from: '', to: '', description: '' }
							]
					    }
                    ]
				},
                errors: {},
                
                vouchercodeChecked: true,
                checkVouchercodeCancelToken: null,

                preFillTestData: {
					industry: 'education',
					name: 'dackus.it',
					address: 'Glacisweg 1b',
					zipcode: '6212 BL',
					city: 'Maastricht',
					country_id: 'NL',
					coc: '',
					vat: '',
					website: '',
					firstname: 'Jordan',
					lastname: 'Drenth',
					telephone: '0433510011',
					email: 'jordan@dackus.it',
					password: 'J0rdan01',
                    password_confirmation: 'J0rdan01',
                    max_guests_inside: 15,
                    max_guests_outside: '',
                    notify_guests: true,
                    color_primary: '#21ae5f',
                    timeslots: [
						{
                            days: [1, 2, 4, 5],
							times: [
                                { from: '09:05', to: '10:30' },
                                { from: '10:35', to: '12:00' },
                                { from: '12:05', to: '13:30' }
							]
                        },
                        {
                            days: [2],
							times: [
                                { from: '13:00', to: '14:30' },
                                { from: '14:30', to: '15:30' }
							]
					    },
                        {
                            days: [3],
							times: [
                                { from: '18:00', to: '19:30' },
                                { from: '20:00', to: '21:30' }
							]
					    }
                    ]
                }
			}
        },
        created: function() {
            // this.form = this.preFillTestData;
        },
		methods: {
            removeTimeslot(index) {
                this.form.timeslots.splice(index, 1);
            },

            addTimeslot() {
                this.form.timeslots.push({
                    days: [1],
                    times: [
                        { from: '', to: '' }
                    ]
                });
            },

            removeTimeslotTime(list, index) {
                list.splice(index, 1);
            },

            addTimeslotTime(list) {
                list.push({ from: '', to: '' });
            },

            daySelected(days, day) {
                return _.includes(days, day);
            },

            toggleDay(days, day) {
                if(this.daySelected(days, day)) {
                    days.splice(_.indexOf(days, day), 1);
                } else {
                    days.push(day);
                }
            },

            isValidTime(time) {
                return /^([0-9]{2}:[0-9]{2})$/.test(time);
            },

            checkVouchercode() {
                this.vouchercodeChecked = false;
                this.checkVouchercodeDebounce();
            },

            checkVouchercodeDebounce: _.debounce(function() {
                if(this.checkVouchercodeCancelToken) {
                    this.checkVouchercodeCancelToken.cancel('cancel_token');
                    this.checkVouchercodeCancelToken = null;
                }

                let cancelToken = axios.CancelToken;
                this.checkVouchercodeCancelToken = cancelToken.source();
                this.add_form_user = null;
                
                axios.post(this.checkVouchercodeUrl, {
                    voucher_code: this.form.voucher_code,
                    install_service: this.form.install_service,
                }, {
                    cancelToken: this.checkVouchercodeCancelToken.token
                })
                .then(response => {
                    
                    this.emailChecked = true;
                    this.checkVouchercodeCancelToken = null;

                    if(response && response.data && response.data.found) {
                        this.price_info.voucher_discount = parseFloat(response.data.discount);
                        this.oprekening_betalen = response.data.oprekening;
                    } else {
                        this.price_info.voucher_discount = 0;
                        this.oprekening_betalen = false;
                    }
                }).catch(error => {
                    if(error && error.message != 'cancel_token') {
                        this.emailChecked = true;
                        this.checkVouchercodeCancelToken = null;
                        this.price_info.voucher_discount = 0;
                        this.oprekening_betalen = false;
                    }
                });
            }, 500),

			onSubmit() {

                let form = {...this.form};

                // form.color_primary = form.color_primary.hex;
				
				this.errors = {};
                
                this.doShowLoader();

				axios.post(this.registerUrl, form)
				.then(response => {
                    this.hideLoader();

					if(response.data.payment_url) {
						window.location.href = response.data.payment_url;						
					}
					Swal.fire({
						icon: 'success',
						title: this.translate('register.success'),
					}).then(() => {
                        if(response.data.oprekening)  {
                            window.location.reload();
                        } else {
                            if(response.data.payment_url) {
                                window.location.href = response.data.payment_url;						
                            }
                        }
					});
				}).catch(error => {
                    this.hideLoader();

					if(error && error.response && error.response.status == 422) {
						this.errors = error.response.data.errors;
					} else {
						Swal.fire({
							icon: 'error',
							title: this.translate('error'),
						});
					}
				});

				return true;
			}
        },
        computed: {
            totalPrice: function() {
                return (this.price_info.base_price + (this.form.install_service ? this.price_info.install_service : 0)) - this.price_info.voucher_discount;
            },
            allTimesValid: function() {
                let valid = true;
                _.each(this.form.timeslots, (timeslot) => { 
                    if(!valid) return false;

                    _.each(timeslot.times, (time) => { 
                        if(!this.isValidTime(time.from)) { // || !this.isValidTime(time.to)
                            valid = false;
                            return false;
                        }
                    });
                });

                return valid;
            }
        }
    }
</script>
